import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { workspaceForLocation } from "./sections";

const HOME = { feasibility: "/feasibility/general", operations: "/ops/desk" };

export default function useWorkspaceNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(() => {
    try {
      return localStorage.getItem("meten_workspace") === "operations" ? "operations" : "feasibility";
    } catch {
      return "feasibility";
    }
  });
  const routeWorkspace = workspaceForLocation(location);
  const workspace = routeWorkspace || selected;
  const lastPath = useRef({ ...HOME });

  useEffect(() => {
    if (routeWorkspace) {
      setSelected(routeWorkspace);
      lastPath.current[routeWorkspace] = `${location.pathname}${location.search}${location.hash}`;
    }
    try {
      localStorage.setItem("meten_workspace", workspace);
    } catch {
      // Navigation still works when browser storage is unavailable.
    }
  }, [routeWorkspace, workspace, location.pathname, location.search, location.hash]);

  const switchWorkspace = useCallback((next) => {
    if (!Object.prototype.hasOwnProperty.call(HOME, next) || next === workspace) return;
    setSelected(next);
    navigate(lastPath.current[next]);
  }, [workspace, navigate]);

  return { workspace, switchWorkspace };
}
